
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning",
      function () {
        return require("private-next-pages/learning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning"])
      });
    }
  